import { Icon } from '@yembo/yemblocks-core';

type Props = {
  requirements: {
    summary: string;
    isMatched: boolean;
  }[];
};

export const RequirementList = ({ requirements }: Props) => (
  <div className='requirements-wrapper'>
    <div className='requirement-title'>Your password must:</div>
    <div className='requirement-list'>
      {requirements.map(({ summary, isMatched }) => (
        <div className={`requirement-item ${isMatched ? 'matched' : ''}`} key={summary}>
          <Icon name='checkmark-circle' />
          <span className='requirement-text tiny-text'>{summary}</span>
        </div>
      ))}
    </div>
  </div>
);
